<template>
  <div class="product_detail_page">

    <div class="detail">
      <b-container>
        <b-row>
          <b-col md="6">
            <div class="product_banner">
              <swiper ref="myProductBanner" :options="bannerOptions">
                <swiper-slide v-for="item in bannerList" :key="item.id" class="product_banner_slide">
                  <img :src="api+item.background">
                </swiper-slide>
              </swiper>

              <div class="swiper-pagination"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>

          </b-col>
          <b-col md="6">
            <div class="info">
              <p class="name clamp2">{{ productDetail.name }}</p>

              <div class="tabs">
                <div class="tab" v-for="(item,index) in tabsList" :key="item.id"
                     :class="{'active':currentTab === index}"
                     @click="switchTab(index)">

                  <div class="box_inner"
                       v-if="index === 0 || ((index === tabsList.length-1) && index > 0)">
                    {{ item.name }}
                  </div>
                  <span v-if="index > 0 && (index < tabsList.length-1)"
                        style="padding: 0 8px;font-family: Akrobat-Bold,Akrobat;">{{ item.name }}</span>
                </div>
              </div>

              <p class="sub" v-if="productDetail.lexarGoodsSpaceList.length">
                {{ productDetail.lexarGoodsSpaceList[currentTab].title }}</p>
              <p class="sub" v-else>{{ productDetail.title }}</p>
            </div>

          </b-col>
        </b-row>

      </b-container>
    </div>

    <div class="product_dec">
      <transition name="fade">
        <div v-if="productDetail.lexarGoodsDescribeListl.length">
          <b-row v-for="item in productDetail.lexarGoodsDescribeListl" class="item clearfix" :key="item.id"
                 :style="{background:item.backgroundColor}">

            <b-col v-if="!item.rightBackground && !item.leftBackground" cols="12">
              <div v-html="item.content" style="padding: 15px 0"></div>
            </b-col>

            <b-col lg="6" :class="{'text-center':item.leftBackground}">
              <img :src="api + item.leftBackground" v-if="item.leftBackground">
              <div class="right content" v-if="item.rightBackground" v-html="item.content"></div>
            </b-col>

            <b-col lg="6" :class="{'text-center':item.rightBackground}">
              <img :src="api + item.rightBackground" v-if="item.rightBackground">
              <div class="content" v-if="item.leftBackground" v-html="item.content"></div>
            </b-col>
          </b-row>
        </div>
      </transition>
    </div>

    <!--    <b-container class="feature">-->
    <!--      <p class="title">特征</p>-->
    <!--      <ul>-->
    <!--        <li class="clamp1">USB Type-C™与USB Type-A双接口设计</li>-->
    <!--        <li class="clamp1">采用高速USB 3.1技术，存储和传输内容更快1</li>-->
    <!--        <li class="clamp1">USB Type-C™与USB Type-A双接口设计</li>-->
    <!--        <li class="clamp1">采用高速USB 3.1技术，存储和传输内容更快1</li>-->
    <!--      </ul>-->
    <!--    </b-container>-->


    <!--    <b-container class="spe">-->
    <!--      <p class="title">规格</p>-->
    <!--      <b-row>-->
    <!--        <b-col cols="3" class="spe_left">-->
    <!--          <ul>-->
    <!--            <li>颜色</li>-->
    <!--            <li>容量</li>-->
    <!--            <li>工作温度</li>-->
    <!--            <li>重量</li>-->
    <!--          </ul>-->
    <!--        </b-col>-->
    <!--        <b-col cols="9" class="spe_right">-->
    <!--          <ul>-->
    <!--            <li>USB Type-C™与USB Type-A双接口设计</li>-->
    <!--            <li>采用高速USB 3.1技术，存储和传输内容更快1</li>-->
    <!--            <li>USB Type-C™与USB Type-A双接口设计</li>-->
    <!--            <li>采用高速USB 3.1技术，存储和传输内容更快1</li>-->
    <!--          </ul>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--    </b-container>-->

    <!--    <b-container class="number">-->
    <!--      <p class="title">产品编号</p>-->

    <!--      <div class="clearfix">-->
    <!--      <table class="table" border="0" v-for="item in 2">-->
    <!--        <tr>-->
    <!--          <th>REGION</th>-->
    <!--          <th>REGION</th>-->
    <!--          <th>REGION</th>-->
    <!--        </tr>-->

    <!--        <tr v-for="item in 3">-->
    <!--          <td>REGIONREGIONREGIONREGIONREGIONREGION</td>-->
    <!--          <td>REGIONREGIONREGIONREGIONREGIONREGION</td>-->
    <!--          <td>REGIONREGIONREGIONREGIONREGIONREGION</td>-->
    <!--        </tr>-->

    <!--      </table>-->
    <!--      </div>-->
    <!--      <b-row>-->
    <!--        <b-col lg="6" md="12" class="clearfix" v-for="item2 in 2">-->
    <!--          <ul class="item" v-for="item in 3">-->
    <!--            <li class="top">REGION</li>-->
    <!--            <li>REGION</li>-->
    <!--            <li>REGION</li>-->
    <!--            <li>REGION</li>-->
    <!--            <li>REGION</li>-->
    <!--          </ul>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--    </b-container>-->

  </div>
</template>

<script>

import {getGoods} from '../api/HomeService'
import {api} from '../api/api';


export default {
  name: "ProductDetail",
  data() {
    return {
      bannerOptions: {
        speed: 300,
        loop: true,
        // effect: 'slide',
        autoplay: {
          delay: 4000
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      languageNum: window.localStorage.getItem("languageNum"),
      api: api,
      tabsList: [],
      currentTab: 0,
      bannerList: [],
      productDetail: {
        lexarGoodsSpaceList: [],
        lexarGoodsDescribeListl: [],
      }

    }
  },
  methods: {
    switchTab(index) {
      this.currentTab = index
      this.bannerList = this.productDetail.lexarGoodsSpaceList[index].lexarGoodsSpaceImgList
    },

    getGoodsDetail() {
      let sendData = {
        languageNum: this.languageNum,
        pageNum: 1,
        pageSize: 4,
        id: this.$route.query.id
      }

      getGoods(sendData, data => {
        this.productDetail = data.rows[0];
        this.tabsList = this.productDetail.lexarGoodsSpaceList;
        this.bannerList = this.productDetail.lexarGoodsSpaceList[0].lexarGoodsSpaceImgList
      })

    },
  },
  created() {
    // this.productDetail = JSON.parse(window.localStorage.getItem("product"))
    this.getGoodsDetail()
    // console.log(this.productDetail)
  }
}
</script>

<style scoped lang="scss" src="../css/productDetail.scss">

</style>